import { SUPPORTED_EXCHANGES } from "../../constants";
import { EXCHANGE_ACCOUNT_DISCONNECTION_REASONS } from "./exchangeAccount.enum";
import z from "zod";

export const HubExchangeAccountSchema = z.object({
  id: z.number(),
  name: z.string(),
  exchangeId: z.union([z.enum(SUPPORTED_EXCHANGES), z.string()]),
  publicApiKey: z.string(),
  status: z.string(),
  hubUserId: z.number(),
  accountId: z.string().nullable().optional(),
  stpGroupId: z.string().nullable().optional(),
  /**
   * Hibachi sub-account index (0 = main crypto account, 1..N = additional
   * sub-accounts). Absent on exchanges without the concept; treat as 0.
   */
  subAccountIdx: z.number().optional(),
  /**
   * Hibachi tradable contract category — "crypto" (default perps) or "fx"
   * (currency pairs requiring a dedicated FX sub-account). Absent on
   * exchanges without the concept; treat as "crypto".
   */
  tradableCategory: z.string().optional(),
});

export type HubExchangeAccount = z.infer<typeof HubExchangeAccountSchema>;

export const HubExchangeAccountDisconnectionSchema = z.object({
  id: z.number(),
  exchangeId: z.union([z.nativeEnum(SUPPORTED_EXCHANGES), z.string()]),
  hubUserId: z.number(),
  accountId: z.string(),
  createdAt: z.coerce.date(),
  reason: z.nativeEnum(EXCHANGE_ACCOUNT_DISCONNECTION_REASONS).nullable().optional(),
});

export type HubExchangeAccountDisconnection = z.infer<typeof HubExchangeAccountDisconnectionSchema>;
